import MosaicsLine from "../../components/layout/MosaicsLine";
import StickySections from "../../components/layout/StickySections";
import LandingGrid from "../LandingGrid";
import Works from "../Works";
import ProjectFalling from "../ProjectFalling";
import OurStory from "../OurStory";
import FAQ from "../FAQ";
import ContactTransition from "../ContactTransition";
import Contact from "../Contact";
import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../globals";


export default function HomePage() {
    
    const baseSections = [
        {
            title: "Communication",
            slug: "communication",
            skills: ["Community Management", "Publicité", "Print", "Statégie"],
            catch_phrase: "Crier haut et fort pour te mettre en lumière",
            text: "On voit loin pour ta com' ! Des stratégies qui tapent dans l’œil et qui te mettent direct dans le champ de vision de ton public. On te fait passer au clair, net et précis.",
            buttons: [
                {
                    "label": "Demander un Call",
                    "href": "/contact"
                },
                {
                    "label": "Voir les Réalisations",
                    "href": "/services/communication"
                }
            ],
            images: [
                {
                    src: "https://zoeil.yanisallali.com/wp-content/uploads/2024/10/categorie_Comm.jpg",
                    alt: "Communication"
                }
            ]
        },
        {
            title: "Graphisme",
            slug: "graphisme",
            skills: ["Identité Visuelle", "Design", "Charte graphique", "Campagne publicitaire"],
            catch_phrase: "Du dessin, mais pas que sur papier",
            text: "Le graphisme, c'est notre super-pouvoir ! On te crée des visuels qui vont flasher ! On met de la couleur dans ta vie pour que ça pète aux yeux de tout le monde !",
            buttons: [
                {
                    "label": "Demander un Call",
                    "href": "/contact"
                },
                {
                    "label": "Voir les Réalisations",
                    "href": "/services/graphisme"
                }
            ],
            images: [
                {
                    src: "https://zoeil.yanisallali.com/wp-content/uploads/2024/10/categorie_graphisme.jpg",
                    alt: "Graphisme"
                }
            ]
        },
        {
            title: "Web Design",
            slug: "web-design",
            skills: ["Site Web","Application","Design system","Web app"],
            catch_phrase: "J’ai juste à reprendre un template",
            text: "On te tisse une toile qui déchire ! Des sites web qui font tourner les têtes et cliquer les souris. On te crée un espace digital qui va faire vibrer ta marque sur tous les écrans !",
            buttons: [
                {
                    "label": "Demander un Call",
                    "href": "/contact"
                },
                {
                    "label": "Voir les Réalisations",
                    "href": "/services/web-design"
                }
            ],
            images: [
                {
                    src: "https://zoeil.yanisallali.com/wp-content/uploads/2024/10/categorie_web_design.jpg",
                    alt: "Web Design"
                }
            ]
        },
        {
            title: "Photo & Video",
            slug: "photo-video",
            skills: ["Courts métrages","Reels","Photos souvenirs","Documentaires"],
            catch_phrase: "Presser la gâchette pour tuer le temps.",
            text: "On capture le vrai, le beau, le fou ! Des photos et vidéos qui en mettent plein la vue, histoire que tes projets sortent de l’ombre et captivent tous les regards.",
            buttons: [
                {
                    "label": "Demander un Call",
                    "href": "/contact"
                },
                {
                    "label": "Voir les Réalisations",
                    "href": "/services/photo-video"
                }
            ],
            images: [
                {
                    src: "https://zoeil.yanisallali.com/wp-content/uploads/2024/10/categorie_photo_video.jpg",
                    alt: "Photo & Video"
                }
            ]
        }
    ];

    return (
        <>
            <LandingGrid />
            <Works />
            <MosaicsLine />
            <ProjectFalling />
            <StickySections
            sections={baseSections} />
            <MosaicsLine />
            <div className="mobile:hidden">
                <MosaicsLine reversed={true} />
            </div>
            <OurStory />
            <FAQ />
            <ContactTransition />
        </>
    )
}